import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SearchNotificationService } from "../search-notification.service";

@Component({
  selector: "app-driver-view-load-search",
  templateUrl: "./driver-view-load-search.component.html",
  styleUrls: ["./driver-view-load-search.component.sass"],
})
export class DriverViewLoadSearchComponent implements OnInit {
  searchDetails: any = null;
  loading = false;

  constructor(
    private searchHistoryService: SearchNotificationService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getSearchDetails();
  }

  getSearchDetails(): void {
    this.route.queryParams.subscribe((params) => {
      const id = params["id"];

      if (!id) {
        console.error("Search history ID not found");
        return;
      }

      this.loading = true;

      this.searchHistoryService.getDriverSearchHistoryById(id).subscribe(
        (res: any) => {
          this.loading = false;

          if (res && res.success) {
            this.searchDetails = res.data;
          } else {
            this.searchDetails = null;
          }
        },
        (error) => {
          this.loading = false;
          this.searchDetails = null;

          console.error("Error fetching driver search history details:", error);
        },
      );
    });
  }

  backToList(): void {
    this.router.navigate(["/dashboard/driver-load-search"]);
  }
}
